import 'normalize.css/normalize.css';
import '@glidejs/glide/dist/css/glide.core.min.css';
import '../icons/css/cnc-icons.css';
import '../scss/main.scss';

import Glide from '@glidejs/glide';
import { h, render } from 'preact';
import objectFitImages from 'object-fit-images';
import smoothscroll from 'smoothscroll-polyfill';

import Nav from './modules/Nav';
import SearchOverlay from './modules/SearchOverlay';
import Animation from './modules/Animation';
import ScrollingContent from './modules/ScrollingContent';
import Locations from './modules/Locations';
import Map from './modules/Map';
import Search from './modules/Search';
import SiteSearch from './modules/SiteSearch';
import Accordion from './modules/Accordion';
import ContentSelector from './modules/ContentSelector';
import Tabs from './modules/Tabs';
//import CookieBar from './modules/CookieBar';
import SmallHeroScroll from './modules/SmallHeroScroll';

// object fit polyfill
objectFitImages('img.js-object-fit');

// smooth scroll polyfill
smoothscroll.polyfill();

const nav = new Nav();
nav.init();

const searchOverlayToggle = document.querySelector('#search-button');
if (searchOverlayToggle) {
  const searchOverlay = new SearchOverlay({ searchOverlayToggle });
  searchOverlay.init();
}

const animation = new Animation();
animation.init();

const scrollingContentSections = document.querySelectorAll(
  '[data-scrolling-content]'
);
for (let el of scrollingContentSections) {
  const scrollingContent = new ScrollingContent(el);
  scrollingContent.init();
}

const glides = document.querySelectorAll('.glide');
for (let glide of glides) {
  const instance = new Glide(glide).mount();
  instance.on('move.after', () => {
    const slides = glide.querySelector('.glide__slides');
    const focusableElements = slides.querySelectorAll(
      'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'
    );
    focusableElements.forEach((el) => {
      if (el.closest('.glide__slide--active')) {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', '-1');
      }
    });
  });
}

const locationsBlock = document.querySelector('#locations');
if (locationsBlock) {
  render(<Locations />, locationsBlock);
}

const searchBlock = document.querySelector('#search-page');
if (searchBlock) {
  const backgroundImage = searchBlock.getAttribute('data-background-image');
  render(<Search backgroundImage={backgroundImage} />, searchBlock);
}

// new sitesearch
const siteSearchBlock = document.querySelector('#sitesearch-page');
if (siteSearchBlock) {
  const backgroundImage = siteSearchBlock.getAttribute('data-background-image');
  render(<SiteSearch backgroundImage={backgroundImage} />, siteSearchBlock);
}

// const cookieBar = document.querySelector('#cookie-bar');
// if (cookieBar) {
//   render(<CookieBar />, cookieBar);
// }

// const maps = document.querySelectorAll('[data-map]');
// for (let el of maps) {
//   const map = new Map(el);
//   map.init();
// }

const accordions = document.querySelectorAll('[data-accordion]');
for (let el of accordions) {
  const accordion = new Accordion(el);
  accordion.init();
}

const contentSelectors = document.querySelectorAll('[data-content-selector]');
for (let el of contentSelectors) {
  const contentSelector = new ContentSelector(el);
  contentSelector.init();
}

const tabbedContent = document.querySelectorAll('[data-tabs]');
for (let el of tabbedContent) {
  const tabs = new Tabs(el);
  tabs.init();
}

const smallHero = document.querySelector('[data-small-hero-scroll]');
if (smallHero) {
  const smallHeroScroll = new SmallHeroScroll(smallHero);
  smallHeroScroll.init();
}
